var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModemy = function SvgModemy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E4F6F2",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEAA",
    d: "M10.575 15.83A14.937 14.937 0 0 1 20 12.5c3.57 0 6.85 1.248 9.425 3.33l-1.047 1.298A13.277 13.277 0 0 0 20 14.167a13.273 13.273 0 0 0-8.378 2.96l-1.047-1.296Zm2.618 3.243A10.788 10.788 0 0 1 20 16.667c2.578 0 4.947.9 6.808 2.405l-1.048 1.296A9.128 9.128 0 0 0 20 18.333a9.132 9.132 0 0 0-5.76 2.035l-1.047-1.296Zm2.618 3.241A6.639 6.639 0 0 1 20 20.834a6.64 6.64 0 0 1 4.19 1.48l-1.048 1.296A4.979 4.979 0 0 0 20 22.5a4.98 4.98 0 0 0-3.142 1.11l-1.047-1.297v.001Zm2.618 3.242c.444-.36.999-.557 1.571-.556.595 0 1.142.208 1.57.555L20 27.5l-1.57-1.945Z"
  })));
};
export default SvgModemy;